<template>
  <v-app id="coachProfile">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({}),
};
</script>
